module.exports = new __parcel__URL__("reports-preview.8bb5ca71.svg").toString();